import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import withStyles from 'isomorphic-style-loader/withStyles';

// components
import EditStoreForm from '../../../../components/SiteAdmin/ManageShop/EditStoreForm';
import Loader from '../../../../components/Common/Loader/Loader';

// style
import s from './EditStore.css';

// graphql
import getShop from './getShop.graphql';
import getCommonSettingQuery from './getCommonSettingQuery.graphql';
export class EditStore extends Component {

    static defaultProps = {
        data: {
            loading: true
        },
        settingData: {
            loading: false
        }
    };

    render() {
        const { data: { loading, getShop } } = this.props;
        const { settingData: { getAllCommonSettingsData, loading: settingLoading } } = this.props;
        let initialValues = {};

        let phoneStatus = getShop && getShop.userVerifiedInfo && getShop.userVerifiedInfo.isPhoneVerified;

        if (!loading && getShop) {
            initialValues = {
                id: getShop.id,
                email: getShop.email,
                phoneDialCode: getShop.phoneDialCode,
                phoneCountryCode: getShop.phoneCountryCode,
                phoneNumber: getShop.phoneNumber,
                profileId: getShop.profile && getShop.profile.profileId,
                shopName: getShop.profile && getShop.profile.shopName,
                firstName: getShop.profile && getShop.profile.firstName,
                lastName: getShop.profile && getShop.profile.lastName,
                country: getShop.profile && getShop.profile.country,
                address: getShop.profile && getShop.profile.address,
                zipcode: getShop.profile && getShop.profile.zipcode,
                picture: getShop.profile && getShop.profile.picture,
                description: getShop.profile && getShop.profile.description,
                priceRange: getShop.profile && getShop.profile.priceRangeId,
                categoryType: getShop && getShop.shopCategory.map((item) => item.categoryId),
                preferredCurrency: getShop.profile && getShop.profile.preferredCurrency,
                shopEstimatedTime: getShop.profile && getShop.profile.shopEstimatedTime,
                dietaryType: getShop.profile && getShop.profile.dietaryType,
                deliveryType: getShop.profile && getShop.profile.deliveryType,
                deliveryName: getShop.profile && getShop.profile.deliveryName,
                isActive: getShop.isActive,
                userStatus: getShop.userStatus,
                isBan: getShop.isBan,
                isDoorStepDelivery: getShop.profile && getShop.profile.isDoorStepDelivery,
                lat: getShop.lat,
                lng: getShop.lng,
                isTakeAway: getShop.profile && getShop.profile.isTakeAway
            }
        };

        return (
            <Loader type={"page"} show={loading}>
                <div className={s.root}>
                    <div className={s.container}>
                        {
                            !loading && initialValues && <EditStoreForm
                                initialValues={initialValues}
                                getDietary={!settingLoading && getAllCommonSettingsData && getAllCommonSettingsData.results && getAllCommonSettingsData.results.length > 0 && getAllCommonSettingsData.results[0]}
                                phoneStatus={phoneStatus}
                                getShop={getShop}
                                deliveryType={initialValues.deliveryType}
                            />
                        }
                    </div>
                </div>
            </Loader>
        );
    }
}

export default compose(withStyles(s),
    graphql(getShop, {
        options: (props) => ({
            variables: {
                id: props.id
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }),
    graphql(getCommonSettingQuery, {
        name: 'settingData',
        options: (props) => ({
            variables: {
                typeId: 1
            },
            fetchPolicy: 'network-only',
            ssr: false
        })
    }),
)(EditStore)